import styled from 'styled-components';
import archImage from '../../assets/persian-arch6.jpg'; 



export const BackgroundContainer = styled.div`
    display: flex;
    
    justify-content: center;
    height: 100%;
    width: 100%;
    background-image: url(${archImage});
    background-size: contain;
    
    
    
`



export const StorytellingContainer = styled.div`
    display: flex;
    justify-content: center;
    height: 100%;
    padding-top: 70px;
    padding-bottom: 3px;
    
`
